module.exports = __webpack_public_path__ + "img/a5.b871eb0f.svg";